import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 40vw;
	min-width: 350px;
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
`;

export const inputsDate = styled.div`
	width: 100%;
	display: flex;
	gap: 1rem;
	align-items: center;
	justify-content: center;
`;

export const inputAndProductFound = styled.div`
	width: 100%;
	display: flex;
	gap: 1rem;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

export const listProducts = styled.div`
	width: 100%;
	height: 300px;
	overflow: auto;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	align-items: flex-start;
	justify-content: flex-start;
	padding: 1rem;
	border: 1px solid ${color.interface.lightGray2};
	border-radius: 5px;
`;

export const product = styled.div<{
	$isSelected: boolean;
}>`
	width: 100%;
	cursor: pointer;
	display: flex;
	gap: 1rem;
	align-items: center;
	justify-content: flex-start;
	border-radius: 5px;
	border: 1px solid ${color.interface.lightGray2};
	padding: 1rem;
	background-color: ${(props) =>
		props.$isSelected ? color.interface.onDragColor2 : color.interface.white};
	transition: all ease 0.1s;

	> img {
		width: 50px;
		height: 50px;
		border-radius: 5px;
		object-fit: initial;
	}

	> p {
		color: ${color.interface.lightGray};
		font-size: 1.4rem;
	}
`;

export const twoInputs = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 1.5rem;

	@media (max-width: 1000px) {
		grid-template-columns: 1fr;
	}
`;

export const emptyList = styled.div`
	width: 100%;
	height: 300px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 5px;
	border: 1px solid ${color.interface.lightGray2};

	> p {
		font-size: 1.5rem;
		font-weight: 900;
		color: ${color.interface.lightGray};
	}
`;

export const centralize = styled.div`
	width: 100%;
	height: 300px;
	display: flex;
	align-items: center;
	justify-content: center;
`;
